const abi = require("./abi.json");
module.exports = {
  56: {
    address: "0x375223d6ed2b7E08bf7Fc552D72ebA403E4B9406",
    abi,
  },
};
